import i18n from "../i18n";

const adminLanguages = {
  "leartbivolaku@gmail.com": "en",
  "zeqirjabivolaku@gmail.com": "de",
};

export const setAdminLanguageByEmail = (email) => {
  const cleanEmail = email?.toLowerCase().trim();
  const lang = adminLanguages[cleanEmail] || "en";

  localStorage.setItem("adminLang", lang);
  i18n.changeLanguage(lang);

  return lang;
};